import Txt, { TxtProps } from '../ui/Txt';
import { mergePropsClassName } from '@/lib/helpers';
import { useCard } from './useCard';
import * as style from './Card.css';
import { fmtFullName } from '@/lib/utils/format';

export type CardTitleProps<D extends React.ElementType = 'h2'> = TxtProps<
  D,
  {
    hover?: boolean;
  }
>;

export const CardTitle = <D extends React.ElementType>({
  children,
  hover,
  ...props
}: CardTitleProps<D>) => {
  const { firstName, lastName, titleComponent, title } = useCard();

  const fullName = fmtFullName(firstName, lastName);
  const content = fullName || title;

  return (
    <Txt
      as={titleComponent || 'h2'}
      variant="h4"
      {...mergePropsClassName(props, style.title({ hover }))}>
      {children || content}
    </Txt>
  );
};
